module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"เพิ่มบริษัทในระบบ","page.description":"เพิ่มข้อมูลบริษัทใหม่ในระบบ","create_company.success":"เพิ่มบริษัท {name} ในระบบเรียบร้อย","company_create.submit.label":"เพิ่มบริษัทใหม่"}}')
  delete Component.options._Ctor
}
